import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-flight-booking-loader',
  templateUrl: './flight-booking-loader.component.html',
  styleUrls: ['./flight-booking-loader.component.scss']
})
export class FlightBookingLoaderComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
